import { panelMeta } from '../../lib/panelMeta';
import VideroMark from './VideroMark';

type PanelBrandLockupProps = {
  title: string;
  subtitle?: string;
  align?: 'center' | 'left';
  compact?: boolean;
  minimal?: boolean;
};

export default function PanelBrandLockup({
  title,
  subtitle,
  align = 'center',
  compact = false,
  minimal = false,
}: PanelBrandLockupProps) {
  const centered = align === 'center';
  const showSubtitle = Boolean(subtitle) && !minimal;
  const titleClassName = minimal
    ? 'text-base font-medium'
    : compact
      ? 'text-2xl'
      : 'text-4xl';

  return (
    <div className={centered ? 'text-center' : 'text-left'}>
      <div className={centered ? 'mx-auto flex w-fit flex-col items-center' : 'flex flex-col items-start'}>
        <span
          className={[
            'flex items-center justify-center rounded-2xl bg-ui-accent text-ui-text-inverse shadow-lg shadow-ui-accent/20',
            minimal ? 'h-14 w-14' : compact ? 'h-14 w-14' : 'h-20 w-20',
          ].join(' ')}
        >
          <VideroMark className={minimal ? 'h-8 w-8' : compact ? 'h-8 w-8' : 'h-11 w-11'} />
        </span>
        <div className={minimal ? 'mt-3' : compact ? 'mt-4 space-y-1' : 'mt-5 space-y-1.5'}>
          <h1 className={['font-semibold tracking-tight text-ui-text', titleClassName].join(' ')}>
            {panelMeta.productName}
          </h1>
          {!minimal ? (
            <p className={compact ? 'text-lg font-medium text-ui-text' : 'text-[1.65rem] font-semibold text-ui-text'}>
              {title}
            </p>
          ) : null}
          {showSubtitle ? (
            <p className="max-w-xl text-sm leading-relaxed text-ui-text-muted">
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
